import { render, staticRenderFns } from "./table_vue.vue?vue&type=template&id=4bb7519c&"
import script from "./table_vue.vue?vue&type=script&lang=js&"
export * from "./table_vue.vue?vue&type=script&lang=js&"
import style0 from "./table_vue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bb7519c')) {
      api.createRecord('4bb7519c', component.options)
    } else {
      api.reload('4bb7519c', component.options)
    }
    module.hot.accept("./table_vue.vue?vue&type=template&id=4bb7519c&", function () {
      api.rerender('4bb7519c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/components/table_vue.vue"
export default component.exports